import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const Help = (): JSX.Element => <HelpOutlineIcon fontSize="inherit" />;

export default Help;
